import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { WeightInput } from 'ui-components/components/weight-input';

import { UnitConversionService } from '../../services/unit-conversion-service';
import { convertToWeightUnitEnum, convertFromWeightUnitEnum } from '../../services/unit-services/weights/weight-unit-enum-converter';
import Global from '../../store/global-selectors';

import type { UnitDisplayType, UnitPosition } from '../../enums/units/unit-display-types';
import type { Weight } from '../../prop-types/weight-types';
import type { WeightUnit } from '../../prop-types/weight-unit';

type ConvertedWeightInputProps = {
  weight?: Weight;
  onChange: (weightValue: number, weightUnit: WeightUnit) => void;
  unitPosition?: UnitPosition;
  unitDisplayType?: UnitDisplayType;
  weightInputInnerContainerClassName?: string;
  inputClassName?: string | null;
  className?: string | null;
};

export const ConvertedWeightInput: React.FC<ConvertedWeightInputProps> = React.memo(
  ({ weight: weightProp, onChange, unitPosition, unitDisplayType, weightInputInnerContainerClassName, inputClassName, className }) => {
    const sellerUnit = useSelector(Global.selectSellerDefaultWeightUnit);
    const convertedUnit = convertFromWeightUnitEnum(sellerUnit);
    const { value, weight, weightUnit } = weightProp || {};
    const convertedValue = UnitConversionService.convertValue(value || weight || 0, weightUnit || sellerUnit, sellerUnit);

    const onWeightChange = useCallback(
      (_value: number, _weightUnit: WeightUnit) => {
        onChange(_value, convertToWeightUnitEnum(_weightUnit));
      },
      [onChange],
    );

    return (
      <WeightInput
        className={className}
        inputClassName={inputClassName}
        onChange={onWeightChange}
        unit={convertedUnit}
        unitDisplayType={unitDisplayType}
        unitPosition={unitPosition}
        weight={convertedValue}
        weightInputInnerContainerClassName={weightInputInnerContainerClassName}
      />
    );
  },
);

ConvertedWeightInput.displayName = 'ConvertedWeightInput';
